import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";

import moment from "moment";
import { useParams } from "react-router-dom";

import "./style.scss";
import { renderAccordionContent } from "@content";

const EditGhost = inject("mainStore")(
    observer(({ mainStore }) => {
        const { secondParam, thirdParam } = useParams();

        let inputsNew = [
            {
                blockName: "Оффер",
                inputs: {
                    technicalName: { label: "Техническое название оффера", type: "string", required: true, addClass: "full", placeholder: "Укажите название для внутреннего использования" },
                    ghostOffer: {
                        type: "radiobutton",
                        radioButtonData: [
                            { label: "Реальная", value: false },
                            { label: "Тестовая (Оффер - призрак)", value: true },
                        ],
                    },
                    vendorId: {
                        label: "Вендора",
                        type: "selectSuggest",
                        apiUrl: "/promo/suggest_list?collection=vendors&project[_id]=1&project[code]=1&project[name]=1&filters[active]=true&sortField=name&sortOrder=asc",
                        dataKey: "suggest.vendors_suggest",
                        optionValue: "_id",
                        optionLabel: "name",
                        placeholder: "Выберите из списка",
                        selectedItemKey: "_id",
                        addClass: "full",
                        required: true,
                        showClear: false,
                        fetchVendorItemData: async (e) => {
                            if (e.value) {
                                const bucketResp = await mainStore.getByUrl(
                                    `/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc&filters[vendorId]=${e.value}`,
                                    false,
                                    "suggest.buckets_suggest",
                                    true,
                                    true,
                                );

                                if (bucketResp && bucketResp.success) {
                                    mainStore.setMainStore("detailData.bucketCode", null);
                                }
                            }
                        },
                    },
                    parentOfferId: {
                        label: "Открыть родительский оффер",
                        type: "linkTab",
                        addClass: "full",
                    },
                },
            },
            {
                blockName: "Нейминг оффера",
                inputs: {
                    title: {
                        type: "string",
                        label: "Название оффера",
                        placeholder: "Введите название",
                        required: true,
                        maxLength: 50,
                    },
                    offerOptions: {
                        label: "Опция предложения",
                        type: "switch",
                        switchLabel: "Хит",
                        keyArray: "hit",
                    },

                    link: {
                        type: "link",
                        href: "https://docs.google.com/document/d/1DFDTRFZDi1witRBBsrS0dBP9SaRFDa-mMaFhPxiJqYU/edit?tab=t.0",
                        label: "Рекомендации к названию оффера можно изучить в документе",
                    },
                },
            },
            {
                blockName: "Превью",
                inputs: {
                    cover: {
                        label: "Desktop",
                        type: "previewItem",
                        pathStorage: "cover",
                        addClass: "full imageupload previewupload",
                    },
                    coverMobile: {
                        label: "Mobile",
                        type: "previewItem",
                        pathStorage: "coverMobile",
                        addClass: "full imageupload previewmobile",
                    },
                    label: {
                        type: "label",
                        label: "Если в оффере используется кастомный логотип, обновите его при наведении на текущий логотип. Используйте Desktop (287x87), Mobile (87х87)",
                        style: { color: "#37404C", fontStyle: "italic" },
                    },
                },
            },
            {
                blockName: "Настройки модального окна оффера призрака",
                inputs: {
                    label: {
                        type: "label",
                        label: "Укажите конфигурацию оффера",
                    },
                    ghostOfferConfig: {
                        type: "objectInputs",
                        inputs: {
                            textTitle: {
                                type: "string",
                                addClass: "full",
                                label: "Заголовок модального окна",
                                required: true,
                            },
                            textDesc: {
                                type: "string",
                                addClass: "full",
                                label: "Описание модального окна",
                                required: true,
                            },
                            typeOffer: {
                                type: "radiobutton",
                                radioButtonData: [
                                    { label: "Обычное модальное окно", value: false, radioNode: { type: "defaultCard", previewType: "ghostDefault" } },
                                    { label: "Модальное окно + ввод почты", value: true, radioNode: { type: "defaultCard", previewType: "ghostEmail" } },
                                ],
                                defaultValue: false,
                            },

                            textAnswer: {
                                type: "textArea",
                                addClass: "full",
                                label: "Укажите заголовок модального окна",
                                required: true,
                                triggerShow: "ghostOfferConfig.typeOffer",
                                triggerShowValue: true,
                            },

                            ghostHeader: {
                                previewType: "ghostHeader",
                                type: "defaultCard",
                                addClass: "full",
                                triggerShow: "ghostOfferConfig.typeOffer",
                                triggerShowValue: true,
                            },
                        },
                    },
                },
            },
            {
                blockName: "Сортировки", //4
                inputs: {
                    offerSites: { type: "offerSortConfig" },
                },
            },
            {
                blockName: "Конфигурация оффера",
                inputs: {
                    // availableOn: {
                    //     label: "Выберите Витрины, где используется оффер",
                    //     type: "multiSelectTemplate",
                    //     required: true,
                    //     apiUrl: "/promo/suggest_list?collection=sites&project[_id]=1&project[code]=1&project[name]=1&sortField=name&sortOrder=asc&filters[active]=true&project[siteInfo]=1",
                    //     refetchOnMountData: true,
                    //     dataKey: "suggest.sites_suggest",
                    //     optionValue: "_id",
                    //     optionLabel: "name",
                    //     placeholder: "Выберите сайты",
                    //     appendTo: "self",
                    //     addClass: "full",
                    //     showSelectAll: true,
                    //     itemTemplate: (option) => {
                    //         if (option.areSame) {
                    //             return (
                    //                 <div className="err">
                    //                     <div>{option?.name}</div>
                    //                     <div className="err__label">Проверьте допустимость публикации</div>
                    //                 </div>
                    //             );
                    //         }

                    //         return option.name;
                    //     },
                    // },

                    offerType: {
                        type: "radiobutton",
                        radioButtonData: [
                            { value: "bucket", label: "Корзина с промокодами" },
                            { value: "onepromo", label: "Единный промокод" },
                            { value: "partnerlink", label: "Ссылка" },
                            { value: "leads", label: "CPL" },
                        ],
                        label: "Вариант выдачи*",
                        require: true,
                    },
                    // onePromo: {
                    //     triggerShow: "offerType",
                    //     triggerShowValue: "onepromo",
                    //     label: "Единый промокод",
                    //     type: "string",
                    //     required: true,
                    // },
                    // bucketCode: {
                    //     triggerShow: "offerType",
                    //     triggerShowValue: "bucket",
                    //     label: "Корзина с промиками",
                    //     type: "selectSuggest",
                    //     filterBy: "title,_id",
                    //     required: true,
                    //     apiUrl: "/promo/suggest_list?collection=buckets&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc",
                    //     dataKey: "suggest.buckets_suggest",
                    //     refetchOnMountData: true,
                    //     optionValue: "code",
                    //     optionLabel: "title",
                    //     placeholder: "Выберите корзину",
                    //     appendTo: "self",
                    //     addAdditionalApi: (data) => `&filters[vendorId]=${data?.vendorId}`,
                    // },
                    // activationLink: {
                    //     label: "Укажите ссылку на активацию",
                    //     required: true,
                    //     type: "string",
                    //     placeholder: "Укажите ссылку",
                    //     triggerShow: "offerType",
                    //     triggerShowValue: ["bucket", "onepromo", "partnerlink"],
                    // },
                    // copyTag: {
                    //     label: "При автоподстановке промокода скопируйте и вставьте тег {{PROMOCODE}}",
                    //     copyLabel: "{{PROMOCODE}}",
                    //     type: "copyTag",
                    //     triggerShow: "offerType",
                    //     triggerShowValue: ["bucket", "onepromo", "partnerlink"],
                    // },
                    // offerDetail: {
                    //     type: "objectInputs",
                    //     inputs: {
                    //         ordRispromo: { label: "ORD Ris Promo", type: "string", required: true, placeholder: "Укажите идентификатор" },
                    //     },
                    // },
                    // offerOptions: {
                    //     label: "Опция предложения",
                    //     type: "switch",
                    //     switchLabel: "Редирект",
                    //     keyArray: "redirect",
                    // },
                },
            },

            {
                blockName: "Коэффициент Виталика 🧢",
                inputs: {
                    brakingCoefficient: {
                        label: "Введите коэффициент",
                        type: "number",
                        defaultValue: 1,
                        required: true,
                        minFractionDigits: 2,
                        maxFractionDigits: 2,
                        min: 0,
                        max: 2,
                        addClass: "small",
                    },

                    copyTag: {
                        label: "Поле заполняется на основании коммерческих договоренностей, значение коэффициента для партнера должно быть согласовано с Виталием Трошко",
                        type: "copyTag",
                    },
                },
            },

            {
                blockName: "Плановые показатели",
                inputs: {
                    alertMetrics: {
                        type: "objectInputs",
                        addClass: "half_screen",
                        inputs: {
                            plannedCtr: {
                                label: "1. Плановый CTR оффера (конверсия из показа в клик)",
                                type: "minMax",
                                addClass: "half_screen",
                                required: true,
                            },
                            plannedCr: {
                                label: `2. Плановый CR (конверсия из клика в "Получить предложение")`,
                                type: "minMax",
                                addClass: "half_screen",
                                required: true,
                            },
                            plannedActivationPercent: {
                                type: "procent",
                                label: "3. Плановый % активаций (не путать с прогнозным!)",
                                placeholder: "Укажите процент %",
                                suffix: " %",
                                addClass: "half_screen",
                                required: true,
                            },
                        },
                    },
                },
            },
            // {
            //     blockName: "Ранжирование",
            //     inputs: {
            //         fixedPositionEnable: {
            //             switchLabel: "Фиксированная сортировка",
            //             type: "switch",
            //             addClass: "full",
            //         },
            //         fixedPositionSort: {
            //             type: "number",
            //             label: "Фиксированная позиция при ранжировании",
            //             triggerShow: "fixedPositionEnable",
            //             triggerShowValue: true,
            //             required: true,
            //         },
            //         sortNum: {
            //             type: "number",
            //             label: "Укажите место на витрине",
            //             required: true,
            //         },
            //     },
            // },
            // {
            //     blockName: "Отправка по API",
            //     inputs: {
            //         radioApi: {
            //             type: "radiobutton",
            //             addClass: "full",
            //             radioButtonData: [
            //                 { label: "Да", value: true },
            //                 { label: "Нет", value: false },
            //             ],
            //             defaultValue: false,
            //             handleChangeRadio: (key, val) => {
            //                 if (!val) {
            //                     mainStore.setMainStore("detailData.apiSendingIds", []);
            //                     return;
            //                 }
            //                 mainStore.setMainStore("detailData.mailOptions.notSend", true);
            //             },
            //         },
            //         apiSendingIds: {
            //             label: "Api Sendings (Отправка по api)",
            //             type: "multiSelectSuggest",
            //             required: true,
            //             apiUrl: "/promo/suggest_list?collection=apisendings&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc",
            //             dataKey: "suggest.apisendings_suggest",
            //             optionValue: "_id",
            //             optionLabel: "title",
            //             placeholder: "Выберите отправку",
            //             appendTo: "self",
            //             triggerShow: "radioApi",
            //             triggerShowValue: true,
            //         },
            //     },
            // },

            {
                blockName: "Ставки",
                inputs: {
                    vendor: {
                        type: "objectInputs",
                        inputs: {
                            rateIds: {
                                type: "rates",
                                apiUrl: "/promo/suggest_list?collection=rates",
                                multiSelect: true,
                                required: true,
                                label: "Ставки",
                            },
                        },
                    },
                    forecastActivationPercent: {
                        type: "procent",
                        label: "Прогнозный процент активаций",
                        placeholder: "Укажите процент %",
                        required: true,
                        // max: 100,
                        suffix: " %",
                        addClass: "half_screen",
                    },
                },
            },

            {
                blockName: "Расписание работы оффера",
                inputs: {
                    dateEndSwitch: {
                        switchLabel: "С датой окончания",
                        type: "switch",
                        addClass: "full",
                        handleChangeSwitch: (key, val, data) => {
                            if (val) {
                                if (data && data.dateEnd && !moment(data.dateEnd).diff(moment(data.dateStart), "years") > 50) {
                                    mainStore.setMainStore("detailData.dateEnd", data.dateEnd);
                                } else {
                                    mainStore.setMainStore("detailData.dateEnd", "");
                                }
                            } else {
                                mainStore.setMainStore("detailData.dateEnd", "2125-01-01T00:00+00:00");
                            }
                        },
                    },
                    dateStart: { label: "Дата начала оффера", type: "dateTime", required: true },
                    dateEnd: {
                        label: "Дата окончания оффера",
                        type: "dateTime",
                        required: true,
                        triggerShow: "dateEndSwitch",
                        triggerShowValue: true,
                    },
                },
            },
            // {
            //     blockName: "Конфигурация письма",
            //     inputs: {
            //         mailOptions: {
            //             label: "Конфиг для писем",
            //             type: "objectInputs",
            //             required: true,
            //             inputs: {
            //                 notSend: {
            //                     type: "radiobutton",
            //                     label: "Отправлять письмо",
            //                     radioButtonData: [
            //                         { label: "Да", value: false },
            //                         { label: "Нет", value: true },
            //                     ],
            //                     defaultValue: false,
            //                     addClass: "full",
            //                 },
            //                 switchKey: {
            //                     type: "switch",
            //                     label: "Уникальная ссылка для письма",
            //                     switchLabel: "Есть",
            //                     keyArray: "",
            //                     handleChangeSwitch: (key, val) => {
            //                         if (!val) {
            //                             mainStore.setMainStore("detailData.mailOptions.mailActivationLink", "");
            //                         }
            //                     },
            //                 },
            //                 mailActivationLink: {
            //                     label: "Ссылка на активацию в письме",
            //                     required: true,
            //                     type: "string",
            //                     placeholder: "Укажите ссылку",
            //                     triggerShow: "mailOptions.switchKey",
            //                     triggerShowValue: true,
            //                 },
            //             },
            //         },
            //     },
            // },
            {
                blockName: "Таргетирование",
                inputs: {
                    switchGeoTarget: {
                        label: "1. Таргетинг по географии оффера (для каких регионов, городов и станций метро будет отображаться оффер)",
                        switchLabel: "Включить",
                        type: "switch",
                        addClass: "full one-line bold",
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.regionIds", []);
                                mainStore.setMainStore("detailData.cityIds", []);
                                mainStore.setMainStore("detailData.metroStationIds", []);
                            }
                        },
                    },
                    keyGeo: {
                        type: "companiesGeo",
                        triggerShow: "switchGeoTarget",
                        triggerShowValue: true,
                    },
                    switchDeviceTarget: {
                        label: "2. Таргетинг по типу устройства и ОС (для каких устройств и ОС будет отображаться оффер)",
                        switchLabel: "Включить",
                        type: "switch",
                        addClass: "full one-line bold",
                        handleChangeSwitch: (key, val) => {
                            if (!val) {
                                mainStore.setMainStore("detailData.deviceTargetModel", null);
                            }
                        },
                    },
                    accordion: {
                        type: "accordion",
                        triggerShow: "switchDeviceTarget",
                        triggerShowValue: true,
                        content: renderAccordionContent(),
                        header: "Как это работает?",
                        addClass: "full logic-help",
                        icon: "pi pi-info-circle",
                    },
                    deviceTargetModel: {
                        type: "deviceTarget",
                        triggerShow: "switchDeviceTarget",
                        triggerShowValue: true,
                    },
                },
            },
        ];

        return (
            <DefaultDetail
                apiUrl={secondParam === "add" ? "/promo/offers" : `/promo/offers/${secondParam}`}
                dataKey={secondParam}
                additionalResend={[
                    {
                        key: "promo_offers_suggest",
                        url: "/promo/suggest_list?collection=offers&project[_id]=1&project[withoutCode]=1&project[title]=1&filters[withoutCode]=false",
                    },
                ]}
                inputs={inputsNew}
                page={"offers"}
                backEnabled={false}
                title="оффер"
            />
        );
    }),
);

export default EditGhost;
